import api from './api';

const userService = {
    // Get all users (admin only)
    getUsers: async (params = {}) => {
        const response = await api.get('/api/users', { params });
        return response.data;
    },

    // Get user by ID
    getUser: async (id) => {
        const response = await api.get(`/api/users/${id}`);
        return response.data;
    },

    // Create new user (admin only)
    createUser: async (userData) => {
        const response = await api.post('/api/users', userData);
        return response.data;
    },

    // Update user (admin only)
    updateUser: async (id, userData) => {
        const response = await api.put(`/api/users/${id}`, userData);
        return response.data;
    },

    // Toggle user status (admin only)
    toggleUserStatus: async (id, status) => {
        const response = await api.patch(`/api/users/${id}/status`, { status });
        return response.data;
    },

    // Reset user password (admin only)
    resetPassword: async (id, password) => {
        const response = await api.patch(`/api/users/${id}/password`, { password });
        return response.data;
    },

    // Delete user (admin only)
    deleteUser: async (id) => {
        const response = await api.delete(`/api/users/${id}`);
        return response.data;
    }
};

export default userService;
